<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-credit-card-lock" icon-small title="مدیریت اعتبارسنجی ها" color="accent">

			<v-row class="mt-5">
				<v-col cols="12" style="padding:0 40px 40px">
					<IranValidityManager :isAdmin="false" :isSummery="false" />
				</v-col>
			</v-row>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'

	export default {
		name: 'IranValidityReports',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			IranValidityManager: () => import('@/components/loanAuthorizations/IranValidityManager'),
		},
		data() {
			return {
				errorMessages: '',
				localData: {},
				selectedRequest: {},
			}
		},
		mounted() {

		},
		methods: {

		},
	}
</script>
<style></style>
